import { Group, Button, TextInput, Textarea } from '@mantine/core';
import { useForm } from '@mantine/form';

import type { TPaymentSystemCreateParams } from '../store/types';

type FormData = {
  name: string;
  data: string;
};

type Props = {
  onSubmit: (params: TPaymentSystemCreateParams) => void;
  onClose: () => void;
};

export const CreatePaymentSystemForm = (props: Props) => {
  const { onSubmit, onClose } = props;

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {
      name: '',
      data: '',
    },
    validate: {
      name: (value) => !value ? 'Введите название' : null,
      data: (value) => !value ? 'Введите данные в формате JSON' : null,
    },
  });

  const handleSubmit = (values: FormData) => {
    const params: TPaymentSystemCreateParams = {
      name: values.name,
      data: JSON.parse(values.data),
    };
    onSubmit(params);
    onClose();
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <TextInput
        label="Название"
        withAsterisk
        key={form.key('name')}
        {...form.getInputProps('name')}
      />
      <Textarea
        label="Данные"
        placeholder="JSON format"
        autosize
        withAsterisk
        key={form.key('data')}
        {...form.getInputProps('data')}
      />

      <Group justify="flex-start" mt="30">
        <Button onClick={onClose} variant="outline">
          Отмена
        </Button>
        <Button type="submit">
          Сохранить
        </Button>
      </Group>
    </form>
  );
};
